import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IbCUserStoreRepositoryService } from 'ib-web-commons/services';
import { filter, take } from 'rxjs';

@Component({
    selector: 'ib-modal-change-status-user',
    templateUrl: './ib-commons-change-status-user-modal.component.html',
    styleUrls: ['./ib-commons-change-status-user-modal.component.scss']
})
export class IbCChangeStatusUserModalComponent {

    public isLoading = false;
    public model = {
        title: 'MODAL_CHANGE_FULL_TO_PERMANENT_TITLE',
        body: 'MODAL_CHANGE_FULL_TO_PERMANENT_TEXT',
        accept: 'MODAL_GENERAL_BUTTON_ACCEPT'
    };

    constructor (
        public activeModal: NgbActiveModal,
        private userStore: IbCUserStoreRepositoryService
    ) {}

    continue () {
        this.isLoading = true;
        this.userStore.updateFromServer();
        this.userStore.getUserState().pipe(
            filter((res) => !res.isLoading),
            take(1)
        )
            .subscribe(() => {
                this.activeModal.close('ACCEPT');
            });
    }

}

